import(/* webpackMode: "eager" */ "/home/ubuntu/download/69589fc9ac898300147148ca/momentum_digital/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69589fc9ac898300147148ca/momentum_digital/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69589fc9ac898300147148ca/momentum_digital/src/app/services/components/PortfolioGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69589fc9ac898300147148ca/momentum_digital/src/app/services/components/ServiceFAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69589fc9ac898300147148ca/momentum_digital/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69589fc9ac898300147148ca/momentum_digital/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69589fc9ac898300147148ca/momentum_digital/src/components/ui/AppImage.tsx");
